// extrnal libraries
// 'landscape'
import html2pdf from 'html2pdf.js'

export function converToPdf(contenedor, name, tipo, margin, scale) {

  if (!margin) {
    margin = 0.3
  }

  if (!scale) {
    scale = 1.5
  }

  var element = document.getElementById(contenedor)
  //
  var opt = {
    margin:       margin,
    filename:     name,
    image:        { type: 'jpeg', quality: 0.50 },
    html2canvas:  { scale: scale, useCORS: true },
    jsPDF:        { unit: 'in', format: 'letter', orientation: tipo }
  }
  //
  html2pdf().set(opt).from(element).save()
}